// AutoMapper
import { AutoMap } from '@nartc/automapper';

import { Type } from 'class-transformer';

// ViewModel
import { InsurerVm } from 'app/_mapper/isurer.vm';

export class PiaCheckResultVm {
    @AutoMap(() => InsurerVm) insurer: InsurerVm;
    @AutoMap() ptiAlarmcenter?: any;
    @AutoMap() policyNumber: string;
    @AutoMap() ptiMandate: string;
    @AutoMap() ptiIntermediary: string;
    @AutoMap() ptiTravelAgency: string;
    @AutoMap() ptiMandatePhoneNumber: string;
    @AutoMap() ptiInsurerPhoneNumber?: any;
    @AutoMap() ptiIntermediaryPhoneNumber: string;
    @AutoMap() ptiTravelAgencyPhoneNumber: string;
    @AutoMap() ptiStatusPolicyCheck: string;
    @AutoMap() ptiTypePolicyCheck: string;
    @AutoMap() ptiComment: string;
    @AutoMap() ptiIsManual: boolean;
    @AutoMap() arrangedBy: string;
    @AutoMap() isSelected: boolean;
    @AutoMap() medicalcosts: boolean;
    @AutoMap() skiing: boolean;
    @AutoMap() crosscountryskiing: boolean;
    @AutoMap() worldcoverage: boolean;
    @AutoMap() europeancoverage: boolean;
    @AutoMap() specialsports: boolean;
    @AutoMap() other: boolean;
    @AutoMap() carassistance: boolean;
    @AutoMap() ptiSecondId: string;
    @AutoMap() id: string;
}
